import React, { useEffect, useState } from "react";
import Informations from "./Informations";
import Adresses from "./Adresses";
import Societe from "./Societe";
import Commission from "./Commission";
import { useDispatch } from "react-redux";
import { getRanges } from "../../../REDUX/actions/range";
import { getOrganizations } from "../../../REDUX/actions/organziation";
import { getCountries } from "../../../REDUX/actions/country";
import { useTranslation } from "react-i18next";

function UpdateApporteurAffaireContent({
  activeTab,
  forms,
  setForms,
  customErrors,
  setCustomErrors,
}) {
  const { i18n } = useTranslation("common");
  const dispatch = useDispatch();

  const handleFormsChange = (name, formData) => {
    setForms({ ...forms, [name]: formData });
  };

  useEffect(() => {
    dispatch(getRanges(i18n.language));
    dispatch(getCountries());
  }, [dispatch, i18n.language]);

  useEffect(() => {
    dispatch(
      getOrganizations({
        $or: [
          { business_affiliate: { id: { $null: true } } },
          { id: { $in: forms?.revendeurs?.map((item) => item?.code) } },
        ],
      })
    );
  }, [dispatch, forms?.revendeurs]);

  switch (activeTab) {
    case "Informations":
      return (
        <Informations
          handleFormsChange={handleFormsChange}
          initialValues={forms.informations}
          customErrors={customErrors}
          setCustomErrors={setCustomErrors}
        />
      );
    case "Addresses":
      return (
        <Adresses
          handleFormsChange={handleFormsChange}
          initialValues={forms.address}
        />
      );
    case "Resellers":
      return (
        <Societe
          handleFormsChange={handleFormsChange}
          initialValues={forms.revendeurs}
        />
      );
    case "Commission":
      return (
        <Commission
          handleFormsChange={handleFormsChange}
          initialValues={forms.comissions}
        />
      );
    default:
      return (
        <Informations
          handleFormsChange={handleFormsChange}
          initialValues={forms.informations}
          customErrors={customErrors}
          setCustomErrors={setCustomErrors}
        />
      );
  }
}

export default UpdateApporteurAffaireContent;
